import { Grid, SubHeading, SelectField, TextAreaField, TextField } from "../Fields";
import { HEIGHTS } from "../../../lib/options";

export default function StepPreferences() {
  return (
    <Grid>
      <SubHeading>Partner preferences</SubHeading>
      <TextField section="preferences" name="age_min" label="Age from" inputMode="numeric" placeholder="e.g. 24" />
      <TextField section="preferences" name="age_max" label="Age to" inputMode="numeric" placeholder="e.g. 30" />
      <SelectField section="preferences" name="height_min" label="Height from" options={HEIGHTS} />
      <SelectField section="preferences" name="height_max" label="Height to" options={HEIGHTS} />
      <TextField section="preferences" name="education" label="Education" placeholder="e.g. Graduate or above" />
      <TextField section="preferences" name="location" label="Location" placeholder="e.g. Kolkata, Bengaluru" />
      <TextField section="preferences" name="community" label="Community" placeholder="e.g. Any / specific caste" className="sm:col-span-2" />
      <TextAreaField section="preferences" name="notes" label="Other expectations" className="sm:col-span-2" />
      <SubHeading>About</SubHeading>
      <TextAreaField section="candidate" name="about" label="About me" rows={5} placeholder="A few lines about personality, values, interests and family" className="sm:col-span-2" />
    </Grid>
  );
}
